import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import { App } from "@/app/App";
import "@/main.css";

const rootElement = document.querySelector("#app")!;

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);

  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
